import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  despacho_estados: [],
  totalCount: 0,
  loading: false,
}

export const Slice = createSlice({
  name: 'despacho_estados',
  initialState,
  reducers: {
    setDespachoEstados: (state, action) => {
      state.despacho_estados = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
})

export const { setDespachoEstados, setTotalCount, setLoading } = Slice.actions
export default Slice.reducer
